import { appEntry } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-2xl mx-auto">
          <div className="rounded-lg border border-background-200/70 bg-background-100 p-6 md:p-10 flex flex-col md:flex-row items-center gap-6 md:gap-10">
            <div className="w-20 h-20 md:w-24 md:h-24 flex-shrink-0 rounded-2xl bg-primary-500 flex items-center justify-center">
              <i className={`text-3xl md:text-4xl text-background-50 ${appEntry.icon}`}></i>
            </div>
            <div className="text-center md:text-left flex-1">
              <h2 className="text-xl md:text-2xl font-heading text-foreground-950 mb-3">
                {appEntry.title}
              </h2>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-5">
                {appEntry.desc}
              </p>
              <a
                href="#hero"
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-md text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-compass-3-line"></i>
                立即访问移动版
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}